
import React from 'react';
import { Card, CardHeader, CardContent, CardFooter } from '@/components/ui/card';
import { Bot, TrendingUp, Target } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

export const BotPreviewCard = () => {
  const { t } = useTranslation();

  return (
    <Card className="w-full max-w-md mx-auto overflow-hidden transition-all duration-300 hover:shadow-lg bg-card">
      <CardHeader className="space-y-1 pb-4">
        <div className="flex items-center gap-2">
          <Bot className="w-5 h-5 text-primary" />
          <h3 className="text-xl font-semibold">{t('preview_bot_name')}</h3>
        </div>
        <p className="text-sm text-muted-foreground">{t('preview_bot_tagline')}</p>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <TrendingUp className="w-4 h-4 text-primary" />
            <span className="text-sm">{t('preview_bot_style')}</span>
          </div>
          <div className="flex items-center gap-3">
            <Target className="w-4 h-4 text-primary" />
            <span className="text-sm">{t('preview_bot_goal')}</span>
          </div>
        </div>
        <div className="mt-4 p-3 bg-primary/5 rounded-lg">
          <p className="text-sm italic text-muted-foreground">
            {t('preview_bot_description')}
          </p>
        </div>
      </CardContent>
      <CardFooter>
        <Button className="w-full" disabled>
          {t('preview_bot_button')}
        </Button>
      </CardFooter>
    </Card>
  );
};
